module.exports = __webpack_public_path__ + "img/7.374a8238.jpg";